import React from 'react';

interface AccountFieldsProps {
  userName: string;
  onChange: (field: 'user_name', value: string) => void;
  errors?: Record<string, string | undefined>;
  disabled?: boolean;
}

// Mỗi học sinh/giáo viên là một tài khoản đăng nhập: BE bắt buộc user_name và tự sinh mật khẩu
// cùng quy tắc với import, trả về plain_password để hiện cho admin sau khi tạo.
const AccountFields: React.FC<AccountFieldsProps> = ({ userName, onChange, errors = {}, disabled }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Tên đăng nhập <span className="text-red-500">*</span>
    </label>
    <input
      type="text"
      name="user_name"
      value={userName}
      onChange={(e) => onChange('user_name', e.target.value)}
      className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
        errors.user_name ? 'border-red-500' : 'border-gray-300'
      }`}
      placeholder="Nhập tên đăng nhập"
      autoComplete="off"
      required
      disabled={disabled}
    />
    {errors.user_name ? (
      <p className="text-red-500 text-sm mt-1">{errors.user_name}</p>
    ) : (
      <p className="text-gray-500 text-xs mt-1">
        Mật khẩu tự tạo: chữ cái đầu mỗi từ trong họ tên (không dấu, viết thường) + 6 ký tự cuối của tên đăng nhập
      </p>
    )}
  </div>
);

export default AccountFields;
